<template>
  <div class="dialog-overlay" v-show="visible" @click="handleOverlayClick">
    <transition name="dialog-fade">
      <div class="dialog-container" v-if="showAnimation" @click.stop>
        <!-- 返回按钮 -->
        <div class="head-icon dialog-back" @click="handleBack" v-if="showBack"></div>
        <!-- 关闭按钮 -->
        <div class="head-icon dialog-close" @click="handleClose" v-if="showClose"></div>

        <!-- 标题部分 -->
        <div class="dialog-header">
          <slot name="title" v-if="title || $slots.title">
            <div class="dialog-title">
              <AutoFitMutilComp
                multi-line
                height="1.0667rem"
                text-align="center"
                :max-font-size="0.5067"
                :text="title"
              ></AutoFitMutilComp>
            </div>
          </slot>
        </div>

        <!-- 内容部分 -->
        <div class="dialog-body">
          <!-- 插槽传递 -->
          <slot></slot>
          <!-- 内容props -->
          <div v-if="content" class="dialog-content">
            {{ content }}
          </div>
        </div>

        <!-- 底部部分 -->
        <div class="dialog-footer">
          <slot
            name="footer"
            v-if="$slots.footer || cancelText || confirmText || $slots.cancel || $slots.confirm"
          >
            <div class="dialog-footer-default">
              <slot name="cancel">
                <div
                  class="button dialog-btn-cancel"
                  :class="cancelBtnClass"
                  @click="handleCancel"
                  v-if="cancelText"
                >
                  {{ cancelText }}
                </div>
              </slot>
              <slot name="confirm">
                <div
                  class="button dialog-btn-confirm"
                  :class="confirmBtnClass"
                  @click="handleConfirm"
                  v-if="confirmText"
                >
                  {{ confirmText }}
                </div>
              </slot>
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  data() {
    return {
      showAnimation: false,
    }
  },
  props: {
    // 控制显示/隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    //内容
    content: {
      type: String,
      default: '',
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // 取消按钮文本
    cancelText: {
      type: String,
      default: '',
    },
    // 确认按钮文本
    confirmText: {
      type: String,
      default: '',
    },
    confirmBtnClass: {
      type: String,
      default: '',
    },
    cancelBtnClass: {
      type: String,
      default: '',
    },
    // 点击遮罩层是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: false,
    },
    // 是否显示返回按钮
    showBack: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 1000,
    },
  },
  emits: ['update:visible', 'close', 'cancel', 'confirm'],
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          // 显示时延迟添加动画类，触发入场动画
          this.$nextTick(() => {
            this.showAnimation = true
          })
        } else {
          // 隐藏时立即移除动画类
          this.showAnimation = false
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 返回
    handleBack() {
      this.$emit('back')
    },
    // 点击遮罩层
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.handleClose()
      }
    },
    // 取消
    handleCancel() {
      this.$emit('cancel')
      this.handleClose()
    },
    // 确认
    handleConfirm() {
      this.$emit('confirm')
      this.handleClose()
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: v-bind(zIndex);
}

.dialog-container {
  background: #ffffff;
  border-radius: 0.32rem;
  width: 9.2rem;
  max-width: 98vw;
  overflow: visible;
  position: relative;
  box-shadow: 0 0.5333rem 1.0667rem rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-out;
  opacity: 1;

  &.dialog-show {
    opacity: 1;
    transform: scale(1);
  }
}

.head-icon {
  position: absolute;
  width: 0.64rem;
  height: 0.64rem;
  top: 0.3733rem;
  cursor: pointer;

  &.dialog-close {
    right: 0.3733rem;
    background: url('./icon_close.png') no-repeat center center;
    background-size: 100% 100%;
  }

  &.dialog-back {
    left: 0.3733rem;
    background: url('./icon_back.png') no-repeat center center;
    background-size: 100% 100%;
  }
}

.dialog-header {
  min-height: 1.3867rem;
  padding: 0 1.0133rem;
  border-bottom: none;
  font-size: 0.5067rem;
  font-weight: 700;
  font-style: Bold;
}

.dialog-title {
  min-height: 1.3867rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dialog-body {
  padding: 0 0.32rem;
  max-height: 60vh;
  overflow-y: auto;
  color: #666;
  line-height: 1.6;
  .dialog-content {
    width: 100%;
    padding: 0.2133rem 0.32rem;
    min-height: 4.2667rem;
    max-height: 8rem;
    background: rgba(242, 244, 248, 1);
    word-break: break-all;
    overflow-y: scroll;
    box-sizing: border-box;
    border-radius: 0.2133rem;
    font-size: 0.3733rem;
    line-height: 1.4;
    color: #62676b;
  }
}

.dialog-footer {
  padding: 0 0.32rem 0.48rem;
  border-top: none;
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog-footer-default {
    width: 100%;
    display: flex;
    margin-top: 0.48rem;
  }
  ::v-deep(.button) {
    & + .button {
      margin-left: 0.32rem;
    }
  }

  .dialog-btn-cancel {
    background-color: #ffffff;
    border: 0.0267rem solid rgba(27, 194, 99, 1);
    color: rgba(27, 194, 99, 1);

    &:active {
      border: 0.0267rem solid rgba(24, 168, 86, 1);
      color: rgba(24, 168, 86, 1);
    }
  }
}

.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: all 0.2s ease-out;
}

.dialog-fade-enter,
.dialog-fade-leave-to,
.dialog-fade-leave-active {
  opacity: 0;
}
</style>
